export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/plus.84daaa89.svg","height":20,"width":20};